<template>
    <page>
        <card :title="'404 - ' + $T('page not found')" title-color="highlight" title-inverted>
            <div class="q-pa-xl text-center">
                <v-button :to="{ name: 'welcome' }" outline color="highlight" :label="$T('go home')"></v-button>
            </div>
        </card>
    </page>
</template>

<script>
    export default {
        layout: 'basic',
        name: 'NotFound'
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/errors/404.vue